import { TechnicianAppointmentsQuery } from "@myapp/contract";
import { normalizeFilters } from "../../../shared/lib/normalizeFilters";

export const appointmentKeys = {
  all: ["appointments"] as const,

  lists: () => [...appointmentKeys.all, "list"] as const,

  list: (filters: TechnicianAppointmentsQuery) =>
    [...appointmentKeys.lists(), normalizeFilters(filters)] as const,

  worker: (technicianId: string, filters: TechnicianAppointmentsQuery) =>
    [...appointmentKeys.all, "worker", technicianId, normalizeFilters(filters)] as const,

  details: () => [...appointmentKeys.all, "detail"] as const,
  detail: (id: string) => [...appointmentKeys.details(), id] as const,

  byWorkOrder: (workOrderId: string) =>
    [...appointmentKeys.all, "byWorkOrder", workOrderId] as const,
};
